import gql from "graphql-tag"
import MESSAGE_FRAGMENT from "./message-fragment"

export default gql`
  query Messages($message_context: MessageContext!, $type: MessageTypeFilter) {
    messages(first: 20, message_context: $message_context, type: $type) {
      edges {
        node {
          ...Message
        }
      }
    }
  }
  ${MESSAGE_FRAGMENT}
`
